module.exports = __webpack_public_path__ + "img/icon__comment.d455d4f9.svg";